module.exports = __webpack_public_path__ + "img/21.d066e2ba.jpg";